"use strict";import e from"../src/express/theme-light.css.js";import{Theme as r}from"../src/Theme.js";import"../src/express/core.js";r.registerThemeFragment("light-express","color",e);
//# sourceMappingURL=theme-light.js.map
